import { useSearchParams } from 'react-router-dom';

import DrugScreenForm from '@/forms/DrugScreenForm';
import Container from '@/ui/components/Container';

const EncounterDetailsNewDrugScreen = () => {
  const [queryParams] = useSearchParams();
  const appointmentId = queryParams.get('appointment-id');

  return (
    <Container type="page">
      <DrugScreenForm appointmentId={appointmentId} />
    </Container>
  );
};

export default EncounterDetailsNewDrugScreen;
